import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UserState {
  // User authentication info
  userName?: string;
  employeeId?: string;
  employeeCompany?: string;
  fullName?: string;
  profileName?: string;
  email?: string;
  locationName?: string;
  isAuthenticated: boolean;

  // Actions
  setUser: (
    userName: string,
    employeeId?: string,
    employeeCompany?: string,
    fullName?: string,
    profileName?: string,
    email?: string,
    locationName?: string
  ) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserState>()(
  persist(
    set => ({
      userName: undefined,
      employeeId: undefined,
      employeeCompany: undefined,
      fullName: undefined,
      profileName: undefined,
      email: undefined,
      locationName: undefined,
      isAuthenticated: false,

      setUser: (
        userName: string,
        employeeId?: string,
        employeeCompany?: string,
        fullName?: string,
        profileName?: string,
        email?: string,
        locationName?: string
      ) =>
        set({
          userName,
          employeeId,
          employeeCompany,
          fullName,
          profileName,
          email,
          locationName,
          isAuthenticated: true
        }),

      clearUser: () =>
        set({
          userName: undefined,
          employeeId: undefined,
          employeeCompany: undefined,
          fullName: undefined,
          profileName: undefined,
          email: undefined,
          locationName: undefined,
          isAuthenticated: false
        })
    }),
    {
      name: 'user-storage',
      partialize: state => ({
        userName: state.userName,
        employeeId: state.employeeId,
        employeeCompany: state.employeeCompany,
        fullName: state.fullName,
        profileName: state.profileName,
        email: state.email,
        locationName: state.locationName,
        isAuthenticated: state.isAuthenticated
      })
    }
  )
);

export const useIsAdmin = () => {
  const profileName = useUserStore(state => state.profileName);
  return profileName === 'System Administrator';
};
